// extracted by mini-css-extract-plugin
module.exports = {"headline":"headline_headline__1AVrK","headline--big":"headline_headline--big__2Fip7"};